import axios from 'axios';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  Grid,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './styles.module.scss';

export function ActivityLog(props) {
  const { id: company_id } = useParams();
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchQueryString, setSearchQueryString] = useState('');

  const context = useContext(ViewContext);

  const format = new DateUtils();

  async function runAPI(page, search) {
    setLoading(true);

    const query =
      startDate !== '' && endDate !== ''
        ? `/api/activitylog?page=${page}&search=${search}&company_id=${company_id}&start_date=${startDate}&end_date=${endDate}`
        : `/api/activitylog?page=${page}&search=${search}&company_id=${company_id}`;

    await axios
      .get(query)
      .then(async (res) => {
        setLoading(false);
        setPayload(res.data.data);

        var tempData = [];

        const timestamp = await format.getTimezone();

        res.data.data.data.map((value, index) => {
          tempData.push({
            id: value.id,
            'Information modified': value.information,
            'Person that modified': value.person,
            'Date modified': format.timestamp(
              value.createdAt,
              timestamp
            ),
          });
        });

        setData(tempData);
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);

        context.notification.show(
          'Failed to load table data',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString, startDate, endDate]);

  useEffect(() => {
    const start_date_input = document.getElementById(
      'start_date_input'
    );
    const end_date_input = document.getElementById('end_date_input');

    if (start_date_input && end_date_input) {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      const todayValue = `${today.getFullYear()}-${
        today.getMonth() + 1 < 10
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1
      }-${
        today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
      }`;
      const tomorrowValue = `${tomorrow.getFullYear()}-${
        tomorrow.getMonth() + 1 < 10
          ? '0' + (tomorrow.getMonth() + 1)
          : tomorrow.getMonth() + 1
      }-${
        tomorrow.getDate() < 10
          ? '0' + tomorrow.getDate()
          : tomorrow.getDate()
      }`;

      document.getElementById('start_date_input').value = todayValue;
      document.getElementById('end_date_input').value = tomorrowValue;
    }
  }, []);

  return (
    <Animate type="pop">
      <div
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        ></div>
      </div>
      <Grid cols="1">
        <div className={styles.wrapper}>
          <div style={{ margin: 20 }}>
            <div className={styles.header}>
              <div className={styles.search}>
                <Search
                  callback={(query) => {
                    setSearchQueryString(query);
                  }}
                />
              </div>
              <div className={styles.field}>
                <label>Start date</label>
                <input
                  type="date"
                  id="start_date_input"
                  onChange={(e) => {
                    setStartDate(e.target.value);
                  }}
                />
              </div>
              <div className={styles.field}>
                <label>End date</label>
                <input
                  type="date"
                  id="end_date_input"
                  onChange={(e) => {
                    const start_date = new Date(
                      new Date(
                        new Date(startDate).setHours(0, 0, 0)
                      ).setDate(new Date(startDate).getDate() + 1)
                    );
                    const end_date = new Date(
                      new Date(
                        new Date(e.target.value).setHours(0, 0, 0)
                      ).setDate(
                        new Date(e.target.value).getDate() + 1
                      )
                    );

                    if (
                      Date.parse(start_date) < Date.parse(end_date)
                    ) {
                      setEndDate(e.target.value);
                    } else {
                      e.preventDefault();

                      context.notification.show(
                        'The "End date" must be in future.',
                        'error',
                        true,
                        'toast',
                        'x-circle'
                      );
                    }
                  }}
                />
              </div>
            </div>
            <Table
              loading={loading}
              data={payload && payload.data ? data : null}
              hide={['link', 'id', 'stated_value']}
            />
            {payload && (
              <Pagination
                pagesCount={payload.pages_count}
                active={payload.page}
                onChange={async (newPage) => {
                  setPage(newPage);
                  runAPI(newPage, searchQueryString);
                }}
              />
            )}
          </div>
        </div>
      </Grid>
    </Animate>
  );
}
